import * as React from 'react';
import DataImage from '../../DataImage';
import {IFoodBanksProps} from '../../utils/models';
import makeSum from '../../../../utils/makeSum';
import image from '../../asset/11. Cold rooms.png';

const ColdRooms = ({submissions}: IFoodBanksProps) => {
    return (
        <DataImage
            image={image}
            value={makeSum(submissions, 'cold_rooms')}
            text='Total cold rooms (m2)'
        />
    );
};

export default ColdRooms;
